import styled from "@emotion/styled";
import { Table } from "@material-ui/core";

export const ResponsiveTable = styled(Table)`
  width: 100%;

  @media (max-width: 600px) {
    display: block;
    tbody,
    tr,
    td,
    th {
      display: block;
    }
    thead {
      display: none;
    }
    tbody {
      height: 400px;
    }
  }

  .medium {
    width: 120px;
  }

  .wide {
    width: 200px;
  }

  .pad-left {
    padding-left: 36px;
  }

  .small {
    padding-left: 36px;
    width: 60px;
  }
`;
